import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0,
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index'),
    },
    {
      path: '/mapdemo',
      name: 'MapDemo',
      component: () => import('@/views/map-demo'),
    },
    {
      path: '/mapdemo2',
      name: 'MapDemo2',
      component: () => import('@/views/map-demo2'),
    },
  ],
})

export default router
